import { socialiteNetworks } from 'socialitejs';

import type { SocialNetworkKeys, SupportedSocialNetworks } from './types';

import {
    SocialLogoDiscord,
    SocialLogoFacebook,
    SocialLogoInstagram,
    SocialLogoLinkedIn,
    SocialLogoTikTok,
    SocialLogoTwitch,
    SocialLogoTwitter,
    SocialLogoYouTube,
} from './icons';

import { SocialNetwork, socialNetworkIds } from './types';
import type { SvgIconComponent } from '@/types';

export const socialNetworkIcon: Record<SupportedSocialNetworks, SvgIconComponent> = {
    [SocialNetwork.Discord]: SocialLogoDiscord,
    [SocialNetwork.Facebook]: SocialLogoFacebook,
    [SocialNetwork.Instagram]: SocialLogoInstagram,
    [SocialNetwork.LinkedIn]: SocialLogoLinkedIn,
    [SocialNetwork.TikTok]: SocialLogoTikTok,
    [SocialNetwork.Twitch]: SocialLogoTwitch,
    [SocialNetwork.Twitter]: SocialLogoTwitter,
    [SocialNetwork.YouTube]: SocialLogoYouTube,
};

export const socialNetworkKeys = Object.keys(SocialNetwork) as SocialNetworkKeys[];
export const socialNetworkData = socialNetworkIds.map((id) => socialiteNetworks[id]);
